import gideon from "../images/speakers/gideon.jpeg";
import danielle from "../images/speakers/danielle.jpeg";
import nick from "../images/speakers/nick.jpeg";
import daniel from "../images/speakers/daniel.jpeg";
import susan from "../images/speakers/susan.jpeg";
import angus from "../images/speakers/angus.jpeg";
import alejandro from "../images/speakers/alejandro.jpeg";
import isikov from "../images/speakers/isikov.jpg";
import cristianablw from "../images/speakers/cristianablw.jpg";
import harry from "../images/speakers/harry.jpg";
import martina from "../images/speakers/martina.jpg";
import alisa from "../images/speakers/alisa.jpg";
import kia from "../images/speakers/kia.jpg";
import abie from "../images/speakers/abie.png";
import steven from "../images/speakers/steven.png";
import steve from "../images/speakers/steve.png";
import feliz from "../images/speakers/feliz.png";
import bill from "../images/speakers/bill.png";
import zachary from "../images/speakers/zachary.png";
import "../styles/home/Speaker2.css";

import blueblack from "../images/speakers/blueblack.avif";

const MediaSpeaker = () => {
  return (
    <div className="container">
      <h2 className="textSize" style={{ color: "blue" }}>
        MEET THE MEDIA ATTENDEES JOINING US IN 2023{" "}
      </h2>
      <div className="inner-container">
        <table>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={gideon} />
                <p className="image-text">
                  Gideon Lichfield <br />
                  Global Editorial Director <br />
                  Wired{" "}
                </p>
              </div>
            </td>

            <td>
              <div className="image">
                <img className="image-contain" src={danielle} />
                <p className="image-text">
                  Danielle Belton <br />
                  Editor-in-chief <br />
                  HuffPost{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={nick} />
                <p className="image-text">
                  Nick Thompson
                  <br />
                  CEO <br />
                  The Atlantic{" "}
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={abie} />
                <p className="image-text">
                  Abbie Lundberg <br />
                  Editor-in-chief
                  <br />
                  MIT Sloan Management Review{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={steven} />
                <p className="image-text">
                  Steven Levy
                  <br />
                  Editor-at-large
                  <br />
                  Wired{" "}
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={daniel} />
                <p className="image-text">
                  Daniel Klaidman <br />
                  Editor-in-Chief <br />
                  Yahoo! News{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={susan} />
                <p className="image-text">
                  Susan Li <br />
                  Business Correspondent <br />
                  Fox Business{" "}
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={steve} />
                <p className="image-text">
                  Steve Clemons
                  <br />
                  Founding editor-at-large <br />
                  Semafor{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={feliz} />
                <p className="image-text">
                  Felice Maranz <br />
                  Editor of Markets Live <br />
                  Bloomberg{" "}
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={bill} />
                <p className="image-text">
                  Bill Owens <br />
                  Executive Producer of 60 Minutes
                  <br />
                  CBS News{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={isikov} />
                <p className="image-text">
                  Michael Isikoff <br />
                  Chief Investigative Correspondent <br />
                  Yahoo! News{" "}
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={cristianablw} />
                <p className="image-text">
                  Cristiana Sousa Cruz
                  <br />
                  Deputy Editor-in-chief <br />
                  GLOBO{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={harry} />
                <p className="image-text">
                  Harry McCracken
                  <br />
                  Global Technology Editor <br />
                  Fast Company
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={blueblack} />
                <p className="image-text">
                  DeRay Mckesson <br />
                  Civil Rights Activist &amp; Podcaster <br />
                  pod save the people{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={kia} />
                <p className="image-text">
                  Kia Kokalitcheva
                  <br />
                  Technology &amp; VC Reporter
                  <br />
                  Axios{" "}
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={zachary} />
                <p className="image-text">
                  Zachary Karabell <br />
                  Contributor <br />
                  Time{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={martina} />
                <p className="image-text">
                  Martina Fuchs <br />
                  Business Correspondent <br />
                  Xinhua News Agency{" "}
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={alisa} />
                <p className="image-text">
                  Alisa Cohn
                  <br />
                  Contributor <br />
                  Forbes{" "}
                </p>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div className="image">
                <img className="image-contain" src={angus} />
                <p className="image-text">
                  Angus Loten
                  <br />
                  Enterprise Reporter <br />
                  The Wall Street Journal
                </p>
              </div>
            </td>
            <td>
              <div className="image">
                <img className="image-contain" src={alejandro} />
                <p className="image-text">
                  Alejandro de la Garza <br />
                  Staff Writer <br />
                  Time{" "}
                </p>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};
export default MediaSpeaker;
